import React, { ReactNode } from 'react';

interface ServiceCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}

const ServiceCard = ({ icon, title, description }: ServiceCardProps) => {
  return (
    <div className="group glass-card p-8 flex flex-col gap-5">
      <div className="w-12 h-12 rounded-2xl bg-brand-50 flex items-center justify-center text-brand-600 transition-colors duration-300 group-hover:bg-brand-600 group-hover:text-white">
        {icon}
      </div>
      <div>
        <h3 className="font-display text-lg font-bold text-slate-900 mb-2">{title}</h3>
        <p className="text-slate-500 text-sm leading-relaxed">{description}</p>
      </div>
      <div className="h-0.5 w-8 bg-gold-400 rounded-full mt-auto transition-all duration-300 group-hover:w-16" />
    </div>
  );
};

export default ServiceCard;
